module.exports = __webpack_public_path__ + "fa-solid-900.6ebcf9f18ded9c54f71ec1198c32aa52.woff2";